import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const r = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M623.979 787.802c27.989-65.344 44.267-152.576 48.149-242.667h137.536c-15.125 109.419-87.467 200.597-185.685 242.667M195.285 545.135h137.557c3.861 90.091 20.139 177.323 48.128 242.667-98.219-42.069-170.56-133.248-185.685-242.667m185.686-328c-27.989 65.365-44.267 152.597-48.128 242.667H195.286c15.125-109.397 87.467-200.576 185.685-242.667m37.205 242.667c7.744-174.208 61.355-267.797 84.309-267.797s76.565 93.589 84.309 267.797H418.175zm84.309 353.152c-22.955 0-76.565-93.611-84.309-267.819h168.619c-7.744 174.208-61.355 267.819-84.309 267.819zm307.179-353.152H672.128c-3.883-90.069-20.16-177.301-48.149-242.667 98.219 42.091 170.56 133.269 185.685 242.667M502.485 106.671c-218.261 0-395.819 177.557-395.819 395.797s177.557 395.819 395.819 395.819c218.24 0 395.797-177.579 395.797-395.819S720.725 106.671 502.485 106.671",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = m(r);
export {
  n as default
};
